import React, { useState, useEffect, useMemo } from "react";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TabsNav from "../common/ProcessNav";
import { Alert, Box } from "@mui/material";
import MultipleInput from "../../../components/Card/MultipleInput";
import Table from "./Table";
import Pagination from "../../../components/Pagination/index";
import Loader from "../../../components/Loader/loader";
import SnackBar from "../../../components/Snackbars/CustomizedSnackbars";
import BatchFilterPopup from "../../investigationAnalysis/review/BatchFilterPopup";
import { useDispatch, useSelector } from "react-redux";
import * as uop from "../../../redux/audit_config/actions";
import ConfirmationDialog from "../../../components/DialogBox/Confirmation";
import debounce from "lodash.debounce";
import { formatLocal } from "../../../utility";

const AuditList = () => {
  const [page, setPage] = useState(1);
  const [filterOpen, setFilterOpen] = useState(false);
  const [openDailog, setOpenDailog] = useState(false);
  const userName = localStorage.getItem("userName");
  const [formData, setFormData] = useState({
    step_name: "",
    site_id: "",
    product_id: "",
    user: userName,
  });
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [openProduct, setOpenProduct] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const rowsPerPage = 50;
  const [addErrors, setAddErrors] = useState();
  const dispatch = useDispatch();
  const rowData = useSelector((state) => state?.auditConfig);
  const lastAuditCaptureDate = rowData?.uoplist?.data?.last_audit_capture_date;
  const [debouncedSearch, setDebouncedSearch] = useState();
  const [search, setSearch] = useState();
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
  });

  const handleReset = () => {
    setFilters({
      from_date: "",
      to_date: "",
    });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getAuditListCall(value);
  };

  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const debouncedSetValue = useMemo(
    () =>
      debounce((val) => {
        setDebouncedSearch(val);
      }, 700),
    [],
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
    debouncedSetValue(e.target.value);
  };

  const getAuditListCall = (page) => {
    const data = {
      page: page,
      page_size: rowsPerPage,
    };
    if (search) data.search = debouncedSearch;
    if (filters.from_date) data.from_date = formatLocal(filters.from_date);
    if (filters.to_date) data.to_date = formatLocal(filters.to_date);
    dispatch(uop.getAuditList(data));
  };

  useEffect(() => {
    setPage(1);
    getAuditListCall(1);
  }, [debouncedSearch]);

  const handleGenerate = () => {
    getAuditListCall(1);
  };

  const handleMenuOption = (option, row) => {
    setSelectedRow(row);
    if (option === "Delete") {
      setOpenDailog(true);
    } else {
      setFormData({
        unit_op_id: row.unit_op_id,
        step_name: row.step_name,
        site_id: row.site_id,
        product_id: row.product_id,
        user: userName,
      });
      setOpenProduct(true);
    }
  };

  return (
    <>
      {" "}
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        {" "}
        <TabsNav />
        <Box sx={{ borderTop: "1px solid #e0e0e0" }}>
          <MultipleInput
            text={"Legacy Audit Trail"}
            searchNotice={
              <Alert
                severity="info"
                sx={{
                  width: "fit-content",
                  maxWidth: "100%",
                  px: 1.5,
                  py: 0.75,
                  fontSize: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  "& .MuiAlert-icon": { py: 0, alignItems: "center" },
                  "& .MuiAlert-message": { py: 0, textAlign: "center" },
                }}
              >
                {lastAuditCaptureDate
                  ? `Legacy audits captured up to ${lastAuditCaptureDate}. Subsequent audits are available in Audit Trail.`
                  : "Legacy audit records only. Subsequent audits are available in Audit Trail."}
              </Alert>
            }
            placeholder={"Search by event name"}
            popupFilter={true}
            // handleChildClick={handleChildClick}
            // handleClick={handleClick}
            // handleMenuOptionCallBack={handleMenuOptionCallBack}
            // filterOptionsGroup1={group1}
            // filterOptionsGroup2={group2}
            // selectedFilters={selectedFilters}
            // handleCheckboxChange={handleCheckboxChange}
            isButton={false}
            // isAuditLogs={true}
            handleSearch={handleSearch}
            search={search}
            // viewAuditLogs={viewAuditLogs}
            // auditText={"Audit Trail"}
            // viewLogs={viewLogs}
            // popupFilter={true}
            handlePopupFilter={() => setFilterOpen(true)}
            // onBackClick={() => setViewLogs(false)}
            isFillterIcon={false}
          />
        </Box>
        {snack?.open && (
          <SnackBar
            className="popup"
            handleClose={() => {
              setSnack({
                open: false,
                message: "",
                severity: "",
              });
            }}
            severity={snack.severity}
            state={snack?.open}
            text={snack?.message}
          />
        )}
        <BatchFilterPopup
          open={filterOpen}
          onClose={() => setFilterOpen(false)}
          filterValues={filters}
          onReset={handleReset}
          onGenerate={handleGenerate}
          // data={auditLogs || []}
          onChange={handleChange}
          isStatusVisible={false}
          // filterOptions={filterOptions}
        />
        <Box width="100%" className="audit-table">
          <ConfirmationDialog
            open={openDailog}
            title="Confirm Deletion"
            message="Do you really want to delete this Unit Operation?"
            // onConfirm={handleDelete}
            // onCancel={() => setOpenDailog(false)}
          />
          <Table
            data={rowData?.uoplist || []}
            moreOption={["Update", "Delete"]}
            handleMenuOption={handleMenuOption}
          />
          {rowData?.uoplist?.loading && <Loader />}
          <Pagination
            count={rowData?.uoplist?.data?.total / rowsPerPage}
            page={page}
            onChange={handlePageChange}
          />
        </Box>
      </InvestigatorContainer>
    </>
  );
};

export default AuditList;
